import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import CharacterShowcase from './components/CharacterShowcase';
import StorySection from './components/StorySection';
import GameplayFeatures from './components/GameplayFeatures';
import LatestArticles from './components/LatestArticles';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

export default function Home() {
  const pageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '挣扎吧亚当君 - 官方首页',
    description: '挣扎吧亚当君官方落地页，探索沉浸式互动叙事体验的无限可能',
    url: 'https://fcyunhan.cn',
    inLanguage: 'zh-CN',
    isPartOf: {
      '@type': 'WebSite',
      name: '挣扎吧亚当君',
      url: 'https://fcyunhan.cn'
    }
  };

  return (
    <>
      <script type="application/ld+json">
        {JSON.stringify(pageSchema)}
      </script>
      <ScrollToTop />
      <Navbar />
      <main>
        <HeroSection />
        <CharacterShowcase />
        <StorySection />
        <GameplayFeatures />
        <LatestArticles />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}